import { 
   BubbleMode,
   CameraPreset,
   CameraEase,
   CharacterMotionType,
   ChoiceType,
   EditedBy,
   FilterPreset,
   CharacterColor,
   RightOrLeft,
   CharacterId,
   ChoiceIdV1,
} from "../../types/types";

export const filterPresets: FilterPreset[] = ['none','sepia','noise','crt','dots','film'];

export const editedBy: EditedBy[] = ['bot', 'creator', 'migrator'];

export const labelColors: CharacterColor[] = ['blue', 'brown', 'green', 'orange', 'purple', 'red', 'teal', 'yellow'];

// enum objects are multidirectional so we need to filter out the actual values
export const characterMotionTypes = Object.values(CharacterMotionType).filter(v => typeof(v) === 'number');

export const cameraPresets: CameraPreset[] = ['closeup', 'medium', 'cowboy', 'wide'];

export const cameraEases: CameraEase[] = ['inOut1', 'shake'];

export const choiceTypes: ChoiceType[] = ['blue', 'premium'];

export const choiceIds: ChoiceIdV1[] = ['a', 'b', 'c'];

export const bubbleModes: BubbleMode[] = ['character', 'scene'];

export const directions: RightOrLeft[] = [1, -1];

export const characterIds: CharacterId[] = ['a', 'b', 'c'];

export const defaultInitialStep = 'DEFAULT_DIALOG!!!';